// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","notification__wrapper":"notification__wrapper-5dKLe","notification__global":"notification__global-1hYXd"};